import {HttpCrudDataSource} from '../../../core/data-source/http-crud.data-source';
import {fromJson} from '../../../core/data-source/json.mapper';
import {httpService} from '../../../core/services/http.service';
import {VehicleChecksReportListRecord} from './vehicle-checks-report-list.record';

export class VehicleChecksReportCrudDataSource<T> extends HttpCrudDataSource<T> {
    protected apiPath: string = '/gt/gt-api/vehicle_checks/submission';

    async getByReference(reference: string): Promise<VehicleChecksReportListRecord> {
        return httpService
            .get(`/gt/gt-api/vehicle_checks/submission/${reference}`)
            .then((response: any) => fromJson(VehicleChecksReportListRecord, response.data));
    }
}
